import { useState } from "react";

import DeleteProjectModalUI from "./DeleteProjectModal.ui.tsx";
import { ExternalProps } from "./DeleteProjectModal.types.tsx";

export const useDeleteProjectModal = ({ onConfirm }: ExternalProps) => {
  const [show, setShow] = useState(false);

  const open = () => setShow(true);
  const close = () => setShow(false);

  const handleConfirm = () => {
    close();
    onConfirm();
  };

  const modal = (
    <DeleteProjectModalUI show={show} handleClose={close} handleConfirm={handleConfirm} />
  );

  return { open, close, modal };
};
